var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07185 0.928147C0.681329 1.31867 0.681329 1.95184 1.07185 2.34236L6.72847 7.99897L1.07083 13.6566C0.680304 14.0471 0.680304 14.6803 1.07083 15.0708C1.46135 15.4614 2.09452 15.4614 2.48504 15.0708L8.14268 9.41319L13.7998 15.0703C14.1903 15.4608 14.8235 15.4608 15.214 15.0703C15.6045 14.6798 15.6045 14.0466 15.214 13.6561L9.55689 7.99897L15.213 2.34291C15.6035 1.95238 15.6035 1.31922 15.213 0.928692C14.8224 0.538168 14.1893 0.538168 13.7987 0.928692L8.14268 6.58476L2.48607 0.928147C2.09554 0.537622 1.46238 0.537622 1.07185 0.928147Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.06f5daf8.svg";
export { ForwardRef as ReactComponent };